import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

export const { getIframePlugin, setIframeEncrypt } = createActions({
  getIframePlugin: result => {
    return result;
  },
  setIframeEncrypt: result => result
});

const initState = Map({
  data: [],
  encryptConfigData: {}
});

const iframePlugin = handleActions(
  {
    [getIframePlugin]: (state, action) => {
      return state.set('data', action.payload.iframes);
    },
    [setIframeEncrypt]: (state, action) => {
      return state.set('encryptConfigData', action.payload.cfg);
    }
  },
  initState
);

export default iframePlugin;
